var React = require('react');

function PanelTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"style":{"fill":"#FFC914"},"d":"M0,141.4L624,10c63.1-13.3,128.9-13.3,192,0l624,131.5"}));
}

PanelTop.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","viewBox":"0 0 1440 141.4","style":{"enableBackground":"new 0 0 1440 141.4"},"xmlSpace":"preserve"};

module.exports = PanelTop;

PanelTop.default = PanelTop;
